import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SmoothScrollService } from '@boatzako/ngx-smooth-scroll';
import { DiscussionService } from '../../../../shared-service/services/discussion.service';

@Component({
  selector: 'comment-child-list',
  templateUrl: './comment-child-list.component.html',
  styleUrls: ['./comment-child-list.component.css']
})
export class CommentChildListComponent implements OnInit {
  @Input()
  parentId:any;
  @Input()
  forumId:any;
  discuss_id:any;
  results=[];
  totalComments:any;
  postReplyId='';
  showLoadMore=true;
  pageIndex=0;
  userData:any;
  userId='';
  profileUrl ='';
  customProfileName='';
  colorPallete = ['green','pink','orange','red','blue', 'gold', 'yelow','violet','silver'];
  colorPick = '';

  constructor(
    private route: ActivatedRoute,
    public discussionService: DiscussionService,
    private smooth: SmoothScrollService,
  ) { }

  ngOnInit() {
    if (localStorage.getItem('userData')){
      this.userData = JSON.parse(localStorage.getItem('userData'));
      this.userId = this.userData.user_id;
    }
    this.smooth.smoothScrollToAnchor();
    this.discuss_id = this.forumId;
    this.colorPick = this.colorPallete[Math.floor(Math.random() * 9)]
    this.discussionService.getChildCommentByDiscussionId(this.discuss_id, this.parentId, this.pageIndex).subscribe(
      (res:any) => {
        if(res.data) {
          this.results = res.data;
          this.pageIndex +=1;
          this.totalComments = res.count;
        }
        this.postReplyId="comment-reply-"+this.parentId+"-sub";
      }
    );
  }

  loadMoreComments() {
    this.discussionService.getChildCommentByDiscussionId(this.discuss_id, this.parentId, this.pageIndex).subscribe(
      (res:any) => {
        if(res.data) {
          this.results = [...this.results,...res.data];
          this.pageIndex +=1;
        } else {
          this.showLoadMore = false;
        }
       // this.postReplyId=Math.floor(Math.random() * 10);
      }
    );
  }

  setCommentFocus() {
    var elmnt = document.getElementById("comment-box-"+this.parentId);
    elmnt.focus();
  }

  refreshComments(event) {
    console.log('child comment called');
    this.results = [...this.results,...event];
  }

  addRemoveUpvote(forum_id, post_type, post_id){
    var formData:any = new FormData();
    formData.append('discussion_type', 'comment');
    formData.append('discussion_id', post_id);
    formData.append('user_id', this.userId);


    console.log(forum_id +'---'+ post_type);
    this.discussionService.addRemoveUpvote(formData).subscribe((result:any) => {
      if(result && result.data && result.data.totlikeData != false) {
        this.results[0].totLikes=result.data.totlikeData;
      } else if(this.results[0].totLikes != 0) {
        this.results[0].totLikes = this.results[0].totLikes-1;
      }
    })
  }

}
